function cdProductList() {(function($){
	const block = '.wp-block-cd-product-list';
	const product = `${block} .product`;
	const heading = `${product}__heading`;
	
	const toggleContainer = (element) => {
		const isOpen    = $(element).hasClass( 'open' );
		$(heading + '.open').each(function(item) {
			$(this).removeClass('open');
			$(this).closest('.product')
				.find('.product__container')
				.slideUp();
		});
		if( !isOpen ) {
			$(element).addClass('open');
			const container = $(element).closest('.product').find('.product__container');
			$(container).slideDown();
		}
	}
	
	$(document).ready(() => {
		if( !$(block).length ) return;
		$(heading).on('click', function(e) {
			e.preventDefault();
			toggleContainer( this );		
		});

		$(heading).on('keydown', function(e) {
			const keysToCheck = [ 'Enter', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown' ];
			if( keysToCheck.includes(e.key) ) {
				e.preventDefault();
				toggleContainer( this );		
			}
		});
	});
}(jQuery))}
cdProductList();